export enum ConcernsSteps {
  CONCERNS,
  SUMMARY
}
